import React from "react";
import CreatableSelect from 'react-select/creatable';
import classNames from "classnames";

const CustomCreatableSelect = ({label, id, placeholder, options, value, onChange, required, isMulti, error}) => {
    return (
        <div className="custom-select">
            {label &&
                <label className={classNames({"required": required})}>
                    {label}
                </label>
            }

            <CreatableSelect
                inputId={id}
                isMulti={isMulti}
                placeholder={placeholder}
                options={options}
                value={value}
                onChange={onChange}
                className={classNames("custom-select", {"wrong-select": error})}
                classNamePrefix="react-select"
                formatCreateLabel={(value) => <span>Add "{value}"</span>}
            />

            {error && <p className="error">{error}</p>}
        </div>
    );
};

export default CustomCreatableSelect;